import React, { useContext, useEffect, useState } from "react";

import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LogoutModal from "../components/LogoutModal";
import Meta from "../components/Meta";
// eslint-disable-next-line
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import SescServices from "../services/handleSesc";
import ImagemTC from "../assets/credencial_plena.png";
import PerfilCV from "../assets/perfil.png";

import ImagemPG from "../assets/credencial_atividades.png";
 // eslint-disable-next-line
import QRCode from "qrcode.react";
import Loader from "../components/Loader";
import { AuthContext } from "../store/AuthContext";
import Barcode from "react-barcode";

const CredencialScreen = () => {
  const { handleLogout, timer } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [clientela, setClientela] = useState("");
  const [matricula, setMatricula] = useState([]);
  const [matriculaVia, setMatriculaVia] = useState("");
  const [vencimento, setVencimento] = useState([]);
  const [via, setVia] = useState("");
  const [foto, setFoto] = useState("");
  
  const [categoria, setCategoria] =  useState("");
  const [tipoCategoria, setTipoCategoria] =  useState("");


  const [perfil, setPerfil] = useState("");

  const [tipo, setTipo] = useState("");
  const [dtNascimento, setDtNascimento] = useState("");
  const [cardVenc, setCardVenc] = useState(false);
  const [sqtitulmat, setSQtitulmat] = useState("");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  function hexToBase64(hexstring) {
    return btoa(
      hexstring
        .match(/\w{2}/g)
        .map(function (a) {
          return String.fromCharCode(parseInt(a, 16));
        })
        .join("")
    );
  }

  //CONFIRMAÇÃO DO PESQUISA DA CRENDENCIAL
  const pesquisa = async () => {
    //const dtAtual = new Date().toISOString().slice(0, 10);
    const resp = await SescServices.helper2(userInfo);

    setSQtitulmat(resp.SQTITULMAT);

    setClientela(resp.NMCLIENTE);
    setVia(resp.NRVIACART);

    let splitsMat = resp.MATFORMAT.split("-");
    setMatricula(splitsMat);

    let matvia = splitsMat.join("");
    setMatriculaVia(matvia.trim());

    const dtAtual = new Date().toISOString().slice(0, 10);
    if (resp.DTVENCTO < dtAtual) {
      setCardVenc(true);
    }

    let dtVenc = resp.DTVENCTO;
    let splits = dtVenc.split("-");
    setVencimento(splits);

    resp.FOTO2 != null ? setFoto(hexToBase64(resp.FOTO2)) : setPerfil(PerfilCV);

    setTipo(resp.TPCATEGORI);
    let dtNasc = resp.DTNASCIMEN;
    let splitsDt = dtNasc.split("-");
    setDtNascimento(splitsDt);

    setCategoria(resp.DSCATEGORI);
    setTipoCategoria(resp.CDCATEGORI);
  };

  useEffect(() => {
    // eslint-disable-next-line

    if (userInfo.cpf) {
      setLoading(true);
      pesquisa();
      setTimeout(function () {
        /*código a ser executado no tempo informado*/
        setLoading(false);
      }, 1000);
    }
    // eslint-disable-next-line
  }, []);

  if (timer === 0) {
    handleLogout();
  }
  if (timer < 3) {
    return (
      <div>Em {timer} segundos, você será desconectado automaticamente</div>
    );
  }

  return (
    <>
      <ToastContainer />
      <Meta />

      <div id="wrapper">
        <Sidebar />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                  <h1 className="h3 mb-0 text-gray-800">Credencial Virtual</h1>
                </div>

                {cardVenc === true ? (
                  <></>
                ) : (
                  <>
                    {tipo === 2 ? (
                      <div className="row">
                        {/* Earnings (Monthly) Card Example */}
                        <div className="col-xl-3 col-md-12 mb-4">
                          <div
                            style={{
                              backgroundImage: `url(${ImagemPG})`,
                              backgroundSize: "auto",
                              backgroundRepeat: "no-repeat",
                              width: "390px",
                              height: "750px",
                              color: "#000000",
                            }}
                          >
                            <p
                              className="text-center"
                              style={{ paddingTop: "110px" }}
                            >
                              {foto ? (
                                <img
                                  src={`data:image/png;base64,${foto}`}
                                  className="rounded-circle"
                                  width="150"
                                  height="150"
                                  alt="perfil"
                                />
                              ) : (
                                <img
                                  src={`${perfil}`}
                                  className="rounded-circle"
                                  width="150"
                                  height="150"
                                  alt="perfil"
                                />
                              )}
                            </p>

                            <p className="text-center">
                              <strong style={{ fontSize: "14px" }}>
                                {clientela}
                              </strong>{" "}
                              <br />
                              {`${dtNascimento[2]}/${dtNascimento[1]}/${dtNascimento[0]}`}
                            </p>

                            {sqtitulmat !== null ? (
                              <p className="text-center">
                                <img
                                  src="/img/IMG_PGDEP.png"
                                  width="215"
                                  height="93"
                                  alt="fundo"
                                />
                              </p>
                            ) : (
                              <p className="text-center">
                                <img
                                  src="/img/IMG_PG.png"
                                  width="215"
                                  height="93"
                                  alt="fundo"
                                />
                              </p>
                            )}

                            <p className="text-center ">
                              {matricula[0] +
                                "-" +
                                matricula[1] +
                                "-" +
                                matricula[2]}


                              <br />
                            


                              
                              {
                                  (() => {
                                      // eslint-disable-next-line eqeqeq
                                      /*if( tipoCategoria === 36 || tipoCategoria === 37 || tipoCategoria === 11 || tipoCategoria === 43 || tipoCategoria === 59 || tipoCategoria === 60) {
                                              return (
                                                  <p>{categoria}</p>
                                              )
                               
                                      }*/


                                      const categoriasPermitidas = [36, 37, 11, 43, 59, 60, 7, 86, 88,91, 78, 48, 19];

                                      if (categoriasPermitidas.includes(tipoCategoria)) {
                                          return <p>{categoria}</p>;
                                      }



                                      
                                  })()  
                              }   





                              {/*<QRCode
                                value={via + matriculaVia}
                                bgColor={"#d1d3d4"}
                                includeMargin={false}
                              />*/}

                              <Barcode
                                value={via + matriculaVia}
                                displayValue= "true"
                                background="#d1d3d4"
                                fontSize="12"
                                format= "CODE128"
                              />


                            </p>
                            <p
                              className="text-center"
                              style={{ paddingTop: "4px" }}
                            >
                              Validade estadual:{" "}
                              {`${vencimento[1]}/${vencimento[0]}`} <br />
                              <strong>Departamento Regional de Alagoas</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        {/* Earnings (Monthly) Card Example */}
                        <div className="col-xl-3 col-md-12 mb-4">
                          <div
                            style={{
                              backgroundImage: `url(${ImagemTC})`,
                              backgroundSize: "auto",
                              backgroundRepeat: "no-repeat",
                              width: "390px",
                              height: "750px",
                              color: "#000000",
                            }}
                          >
                            <p
                              className="text-center"
                              style={{ paddingTop: "105px" }}
                            >
                              {foto ? (
                                <img
                                  src={`data:image/png;base64,${foto}`}
                                  className="rounded-circle"
                                  width="150"
                                  height="150"
                                  alt="perfil"
                                />
                              ) : (
                                <img
                                  src={`${perfil}`}
                                  className="rounded-circle"
                                  width="150"
                                  height="150"
                                  alt="perfil"
                                />
                              )}
                            </p>

                            <p className="text-center">
                              <strong style={{ fontSize: "14px" }}>
                                {clientela}
                              </strong>{" "}
                              <br />
                              {`${dtNascimento[2]}/${dtNascimento[1]}/${dtNascimento[0]}`}
                            </p>

                            {sqtitulmat !== null ? (
                              <p className="text-center">
                                <img
                                  src="/img/IMG_TCDEP.png"
                                  width="215"
                                  height="97"
                                  alt="fundo"
                                />
                              </p>
                            ) : (
                              <p className="text-center">
                                <img
                                  src="/img/IMG_TC.png"
                                  width="215"
                                  height="97"
                                  alt="fundo"
                                />
                              </p>
                            )}

                            <p className="text-center ">
                              {matricula[0] +
                                "-" +
                                matricula[1] +
                                "-" +
                                matricula[2]}
                              <br />

                              

                              
                              <Barcode
                                value={via + matriculaVia}
                                displayValue= "true"
                                background="#ffbd00"
                                fontSize="12"
                                format= "CODE128"
                                
                              />
                              ,
                            </p>

                          
                            <p
                              className="text-center"
                              style={{ paddingTop: "4px" }}
                            >
                              Validade nacional:
                              {`${vencimento[1]}/${vencimento[0]}`} <br />
                              <strong>Departamento Regional de Alagoas</strong>
                             
                            </p>
                           
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
      <LogoutModal />
    </>
  );
};

export default CredencialScreen;
